import { api_endpoints } from '../constants';
import { error as logError, log } from '../helper/logger';

// User API Services
export const submitUserData = async (userData) => {
    // Same reasoning as submitEventData below - don't register real-looking user
    // rows in the backend from dev/local sessions.
    if (process.env.NODE_ENV !== 'production') {
        log('Skipping submitUserData in non-production environment:', userData);
        return null;
    }

    try {
        const response = await fetch(api_endpoints.create_user, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(userData),
        });
        if (!response.ok) {
            throw new Error('Failed to create user');
        }
        return await response.json();
    } catch (error) {
        logError('Error creating user:', error);
        throw error;
    }
};

// Event API Services
export const createEvent = async (eventData) => {
    try {
        const response = await fetch(api_endpoints.create_event, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(eventData),
        });
        if (!response.ok) {
            throw new Error('Failed to create event');
        }
        return await response.json();
    } catch (error) {
        logError('Error creating event:', error);
        throw error;
    }
};

// Board API Services
export const getBoardByBoardNumber = async (boardNum) => {
    try {
        const response = await fetch(api_endpoints.get_board_by_board(boardNum));
        if (!response.ok) {
            throw new Error(`Failed to fetch board for board ${boardNum}`);
        }
        return await response.json();
    } catch (error) {
        logError('Error fetching board by board number:', error);
        throw error;
    }
};

export const getAllBoards = async () => {
    try {
        const response = await fetch(api_endpoints.get_all_boards);
        if (!response.ok) {
            throw new Error('Failed to fetch all boards');
        }
        return await response.json();
    } catch (error) {
        logError('Error fetching all boards:', error);
        throw error;
    }
};

export const getTodaysBoard = async () => {
    try {
        const response = await fetch(api_endpoints.get_todays_board);
        if (!response.ok) {
            throw new Error('Failed to fetch today\'s board');
        }
        return await response.json();
    } catch (error) {
        logError('Error fetching today\'s board:', error);
        throw error;
    }
};

export const submitEventData = async (eventData) => {
    // Board-completion results are real gameplay data - keep dev/local sessions from
    // writing into the same backend as production so the two datasets don't mix.
    if (process.env.NODE_ENV !== 'production') {
        log('Skipping submitEventData in non-production environment:', eventData);
        return null;
    }

    try {
        const response = await fetch(api_endpoints.submit_event_data, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(eventData),
        });
        if (!response.ok) {
            throw new Error('Failed to submit board data');
        }
        return await response.json();
    } catch (error) {
        logError('Error submitting board data:', error);
        throw error;
    }
};